<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Inventory Issuances Report</h1>
    <div class="flex items-center mb-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Date</th>
          <th class="pb-4 pt-6 px-6">Part Number</th>
          <th class="pb-4 pt-6 px-6">Part Description</th>
          <th class="pb-4 pt-6 px-6">Category</th>
          <!--<th class="pb-4 pt-6 px-6">Count</th>-->
          <th class="pb-4 pt-6 px-6">Quantity</th>
          <th class="pb-4 pt-6 px-6">UoM</th>
          <th class="pb-4 pt-6 px-6">Location</th>
          <!-- <th class="pb-4 pt-6 px-6">User</th> -->
        </tr>
        <tr
          v-for="inventory in summationReports"
          :key="inventory.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.date }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.sku_name }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.category }}
            </span>
          </td>
          <td class="w-px border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500 text-right">
              {{ inventory.quantity.toFixed(2) }}
            </span>
          </td>
          <td class="w-px border-t text-center">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.unit_of_measure }}
            </span>
          </td>
          <td class="w-px border-t text-center">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.location }}
            </span>
          </td>
          <!--
          <td class="w-px border-t text-center">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ inventory.user }}
            </span>
          </td> -->
        </tr>
        <tr v-if="issuances.length === 0">
          <td class="px-6 py-4 border-t" colspan="7">No data found</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'

export default {
  components: {
    Head,
    SearchWithDateRange,
    DateRange
  },
  layout: Layout,
  props: {
    filters: Object,
    issuances: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
      },
    }
  },
  computed: {
    summationReports() {
      let sumsArray = {}
      const data = this.issuances
      let sums = {}
      data.forEach(item => {
        sums = sumsArray[item.sku_name]
        if (sums) {
          sums.total += Number(item.total)
          sums.quantity += Number(item.quantity)
        } else {
          sumsArray[item.sku_name] = {
            sku_name: item.sku_name,
            description: item.description,
            category: item.category,
            date: item.date,
            unit_of_measure: item.unit_of_measure,
            total: Number(item.total),
            quantity: Number(item.quantity),
            user: item.user,
            location: item.location
          }
        }
      })
      return Object.values(sumsArray)
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/issuance/reports', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
